import React from 'react'
import WingoChat from '@web/assets/wingo-chat.png'
import { leftComponentVariants } from '../styles'

const { image } = leftComponentVariants()

const LeftComponent = () => (
  <img
    className={image()}
    src={WingoChat}
    alt='Wingo Chat'
  />
)

export default LeftComponent
